import * as React from 'react';
export const easternbankSvg = React.forwardRef(function easternbankSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M0 0h32v32H0z',
        fill: '#00467f',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M15.902 6.008c7.346.082 11.04 5.388 11.04 9.796 0 3.714-2.358 9.225-10.215 9.878-2.436-2.164-1.414-5.347-.943-6.082.629-.898 6.482-7.306 6.482-7.306l-2.868-2.857s-5.068 5.428-6.207 6.734c-1.179 1.347-1.69 4-.354 6.245 0 0 1.847 2 3.183 3.266-6.836-.041-12.061-5.755-10.843-11.47 1.178-5.47 5.735-8.367 10.528-8.204 0 0-4.675 5.184-6.285 6.98-1.611 1.796-.983 5.102.078 6.204 1.06 1.102 1.65 1.632 1.65 1.632s-.707-3.06 1.729-5.673c2.435-2.571 5.853-6.408 5.853-6.408s-2.75-2.653-2.828-2.735zm1.453 19.143 8.525-9.306-2.907-2.898-5.382 5.837c-1.925 2.326-1.846 4.49-.236 6.367z',
        fill: '#fff',
        fillRule: 'nonzero',
      }),
    ),
  );
});
easternbankSvg.defaultProps = {
  height: '32',
  viewBox: '0 0 32 32',
  width: '32',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var easternbank = {
  category: 'brand',
  colorable: false,
  name: 'easternbank',
  svg: easternbankSvg,
};
